import { Action, ErrorCodes, OperationType, Position, WarningType, WindowType } from "puzzle";
import CommentWarning from "../../components/Drawer/Tabs/Files/WarrningDialogs/CommentWarning";
import ActionCannotBeRevertedWarning
  from "../../components/Drawer/Tabs/Files/WarrningDialogs/ActionCannotBeRevertedWarning";
import { FileHasNoChanges } from "../../components/Drawer/Tabs/Files/WarrningDialogs/FileHasNoChanges";
import { FileNotMarkedAsCompleted } from "../../components/Drawer/Tabs/Files/WarrningDialogs/FileNotMarkedAsCompleted";

export const startPromoteFiles: Action = [{
  data: {
    promoteFilesAction: 'promoteFiles'
  },
  type: OperationType.data
}, {
  persistent: ['actionName', 'selectAll', 'executionModuleName', 'previousPhase', 'promoteFilesAction'],
  type: OperationType.addPersistentData
}, {
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'createRequestParams',
  args: ['selectAll'],
  mappingName: 'requestData',
  type: OperationType.addOperationData
}, {
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'updateParamsForPreconditionCheck',
  args: ['requestData', 'selectAll'],
  mappingName: 'requestDataForPreconditionsCheck',
  type: OperationType.addOperationData
}, {
  persistent: ['requestData'],
  type: OperationType.addPersistentData
}, {
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'getMandatoryCommentEnabled',
  mappingName: 'mandatoryCommentEnabled',
  args: ['actionName', 'selectAll'],
  type: OperationType.addOperationData
}, {
  condition: '{mandatoryCommentEnabled}',
  conditionOperations: [{
    data: {
      template: {
        method: 'post',
        bind: {
          url: "'/submissions/' + {selectedSubmissions[0].submissionId} + '/promoteDemotePreconditionsCheck'",
          params: '{requestDataForPreconditionsCheck}'
        }
      },
    },
    mappingName: 'mandatoryComments',
    type: OperationType.request
  }, {
    evaluate: true,
    moduleName: '{executionModuleName}',
    args: ['actionName', 'mandatoryComments'],
    name: 'setMandatoryCommentsFlag'
  }],
  type: OperationType.conditional
}, {
  name: 'promoteFiles',
  type: OperationType.action
}];

export const clearPromoteData: Action = [{
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'clearWarringFlags'
}, {
  persistent: ['actionName', 'selectAll', 'executionModuleName', 'previousPhase', 'promoteRequestData', 'promoteFilesAction', 'gsSaveRequestData'],
  type: OperationType.removePersistentData
}];


export const samePhaseWarning: Action = [{
  placeholders: {
    className: 'tp-text-semibold',
    template: {
      bind: {
        actionText: '{actionNameLocale}',
      }
    }
  },
  warningType: WarningType.warning,
  className: 'sm warning footer-centered',
  title: 'filesTabPromoteDemoteWarnings.samePhase.title',
  text: 'filesTabPromoteDemoteWarnings.samePhase.warningMsg',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }]
  }, {
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }],
    btnName: 'filesTabPromoteDemoteWarnings.close',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }],
  type: OperationType.warning
}]

export const sameWorkflowWarning: Action = [{
  placeholders: {
    className: 'tp-text-semibold',
    template: {
      bind: {
        actionText: '{actionNameLocale}',
        text: '{text}'
      }
    }
  },
  warningType: WarningType.warning,
  className: 'sm warning footer-centered',
  title: 'filesTabPromoteDemoteWarnings.title',
  text: 'filesTabPromoteDemoteWarnings.warningMsg',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }]
  }, {
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }],
    btnName: 'filesTabPromoteDemoteWarnings.close',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }],
  type: OperationType.warning
}];

export const promoteFiles: Action = [{
  evaluate: true,
  moduleName: '{executionModuleName}',
  name: 'getWarningFlags',
  mappingName: 'warningFlags',
  args: ['actionName', 'selectAll'],
  type: OperationType.addOperationData
}, {
  condition: '{warningFlags.flagSum}',
  conditionOperations: [{
    moduleName: 'App',
    type: OperationType.maskModule
  }, {
    condition: '{gsSaveRequestData}',
    conditionOperations: [{
      name: 'saveGradingAndScoringRequest',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }, {
    evaluate: true,
    moduleName: '{executionModuleName}',
    name: 'getComment',
    mappingName: 'promoteDemoteComment',
    type: OperationType.addOperationData
  }, {
    condition: '!!{promoteDemoteComment} && !_.get({gsSaveRequestData}, "commentParams")',
    conditionOperations: [{
      evaluate: true,
      moduleName: '{executionModuleName}',
      name: 'createCommentsRequestParams',
      args: ['actionName', 'requestData'],
      mappingName: 'commentsRequestParams',
      type: OperationType.addOperationData
    }, {
      data: {
        template: {
          method: 'post',
          bind: {
            url: "'/submissions/' + {selectedSubmissions[0].submissionId} + '/comments/add'",
            params: '{commentsRequestParams}'
          }
        },
      },
      mappingName: 'commentsResponse',
      type: OperationType.request
    }, { //TODO ADD SUUCESS
      name: 'initiatePromotePinger',
      type: OperationType.action
    }],
    elseOperations: [{
      name: 'initiatePromotePinger',
      type: OperationType.action
    }],
    type: OperationType.conditional,
  }],
  elseOperations: [{
    evaluate: true,
    moduleName: '{executionModuleName}',
    name: 'getLocalization',
    args: ['actionName'],
    type: OperationType.addOperationData
  }, {
    name: 'promoteWarning',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const initiatePromotePinger: Action = [{
  data: {
    template: {
      method: 'post',
      bind: {
        url: "'/submissions/' + {selectedSubmissions[0].submissionId} + '/' + {actionName}",
        params: '{requestData}'
      }
    },
  },
  mappingName: 'promoteRequestData',
  type: OperationType.request
}, {
  name: 'promotePing',
  type: OperationType.action
}];


export const promoteWarning: Action = [{
  condition: '{warningFlags.gradingAndScoring}',
  conditionOperations: [{
    name: 'mandatoryGradeWarning',
    type: OperationType.action
  }],
  elseOperations: [{
    condition: '{warningFlags.promoteCommentMandatoryEnabled} || {warningFlags.demoteCommentMandatoryEnabled} || {warningFlags.generalReturnWarning}',
    conditionOperations: [{
      data: {
        template: {
          bind: {
            generalReturnFlag: '{warningFlags.generalReturnWarning}'
          }
        }
      },
      type: OperationType.data
    }, {
      placeholders: {
        template: {
          bind: {
            title: `_.get({getLocalization},'titleLocale')`,
            btn: `_.get({getLocalization},'btnLocale')`
          }
        }
      },
      className: 'sm footer-centered',
      title: 'commentWarning.title',
      children: [{
        render: CommentWarning,
        propArgs: ['actionName', 'generalReturnFlag']
      }],
      items: [{
        operations: [{
          name: 'clearPromoteData',
          type: OperationType.action
        }],
        btnName: 'commentWarning.cancel',
        btnConfig: {
          fillMode: 'flat',
          pos: Position.end
        }
      }, {
        close: false,
        operations: [{
          moduleName: 'CommentWarning',
          name: 'getCommentValue',
          mappingName: 'commentValue',
          type: OperationType.addOperationData
        }, {
          data: {
            template: {
              bind: {
                flagForChange: `{actionName} === "promote" ? 'promoteCommentMandatoryEnabled' : 'demoteCommentMandatoryEnabled'`
              }
            }
          },
          evaluate: true,
          moduleName: '{executionModuleName}',
          name: 'setWarningFlags',
          args: ['flagForChange', 'commentValue']
        }, {
          windowType: WindowType.dialog,
          type: OperationType.closeWindow
        }, {
          evaluate: true,
          name: '{promoteFilesAction}',
          type: OperationType.action
        }],
        btnName: 'commentWarning.btn',
        btnConfig: {
          pos: Position.end,
          disabled: true,
          themeColor: 'primary'
        }
      }, {
        btnName: 'ESCAPE',
        operations: [{
          name: 'clearPromoteData',
          type: OperationType.action
        }]
      }],
      type: OperationType.dialog
    }],
    elseOperations: [{
      name: 'actionCannotBeRevertedEnabledWarning',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];


export const actionCannotBeRevertedEnabledWarning: Action = [{
  condition: '{warningFlags.actionCannotBeRevertedEnabled}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          showCheckbox: '{warningFlags.promoteDemoteDisclaimerEnabled}'
        }
      }
    },
    type: OperationType.data
  }, {
    placeholders: {
      template: {
        bind: {
          title: `_.get({getLocalization},'titleLocale')`,
          btn: `_.get({getLocalization},'btnLocale')`
        }
      }
    },
    className: 'sm warning footer-centered',
    title: 'actionCannotBeRevertedWarning.title',
    children: [{
      render: ActionCannotBeRevertedWarning,
      propArgs: ['showCheckbox', 'actionName', 'previousPhase']
    }],
    items: [{
      btnName: 'ESCAPE',
      operations: [{
        name: 'clearPromoteData',
        type: OperationType.action
      }]
    }, {
      operations: [{
        name: 'clearPromoteData',
        type: OperationType.action
      }],
      btnName: 'actionCannotBeRevertedWarning.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }, {
      close: false,
      operations: [{
        data: {
          flagsForChange: ['actionCannotBeRevertedEnabled', 'promoteDemoteDisclaimerEnabled']
        },
        evaluate: true,
        moduleName: '{executionModuleName}',
        name: 'setWarningFlags',
        args: ['flagsForChange']
      }, {
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }, {
        evaluate: true,
        name: '{promoteFilesAction}',
        type: OperationType.action
      }],
      btnName: 'actionCannotBeRevertedWarning.btn',
      btnConfig: {
        pos: Position.end,
        disabled: true,
        themeColor: 'primary'
      }
    }],
    type: OperationType.dialog
  }],
  elseOperations: [{
    name: 'fileHasNoChangesEnabledWarning',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const fileHasNoChangesEnabledWarning: Action = [{
  condition: '{warningFlags.fileHasNoChangesEnabled}',
  conditionOperations: [{
    placeholders: {
      template: {
        bind: {
          title: `_.get({getLocalization},'titleLocale')`,
          btn: `_.get({getLocalization},'btnLocale')`,
        }
      }
    },
    className: 'sm warning footer-centered',
    title: 'filesTabPromoteDemoteWarnings.fileHasNoChangesEnabled.title',
    children: [{
      render: FileHasNoChanges,
      propArgs: ['actionName', 'previousPhase']
    }],
    items: [{
      btnName: 'ESCAPE',
      operations: [{
        name: 'clearPromoteData',
        type: OperationType.action
      }]
    }, {
      operations: [{
        name: 'clearPromoteData',
        type: OperationType.action
      }],
      btnName: 'filesTabPromoteDemoteWarnings.fileHasNoChangesEnabled.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }, {
      close: false,
      operations: [{
        data: {
          flagsForChange: 'fileHasNoChangesEnabled'
        },
        evaluate: true,
        moduleName: '{executionModuleName}',
        name: 'setWarningFlags',
        args: ['flagsForChange']
      }, {
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }, {
        evaluate: true,
        name: '{promoteFilesAction}',
        type: OperationType.action
      }],
      btnName: 'filesTabPromoteDemoteWarnings.fileHasNoChangesEnabled.btn',
      btnConfig: {
        pos: Position.end,
        themeColor: 'primary'
      }
    }],
    type: OperationType.dialog
  }],
  elseOperations: [{
    name: 'fileNotMarkedAsCompletedEnabledWarning',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const fileNotMarkedAsCompletedEnabledWarning: Action = [{
  condition: '{warningFlags.fileNotMarkedAsCompletedEnabled}',
  conditionOperations: [{
    placeholders: {
      template: {
        bind: {
          title: `_.get({getLocalization},'titleLocale')`,
          btn: `_.get({getLocalization},'btnLocale')`,
        }
      }
    },
    className: 'sm warning footer-centered',
    title: 'filesTabPromoteDemoteWarnings.fileNotMarkedAsCompleted.title',
    children: [{
      render: FileNotMarkedAsCompleted,
      propArgs: ['actionName', 'previousPhase']
    }],
    items: [{
      btnName: 'ESCAPE',
      operations: [{
        name: 'clearPromoteData',
        type: OperationType.action
      }]
    }, {
      operations: [{
        name: 'clearPromoteData',
        type: OperationType.action
      }],
      btnName: 'filesTabPromoteDemoteWarnings.fileNotMarkedAsCompleted.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }, {
      operations: [{
        data: {
          flagsForChange: 'fileNotMarkedAsCompletedEnabled'
        },
        evaluate: true,
        moduleName: '{executionModuleName}',
        name: 'setWarningFlags',
        args: ['flagsForChange']
      }, {
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }, {
        evaluate: true,
        name: '{promoteFilesAction}',
        type: OperationType.action
      }],
      btnName: 'filesTabPromoteDemoteWarnings.fileNotMarkedAsCompleted.btn',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end,
        themeColor: 'primary',
      }
    }],
    type: OperationType.dialog
  }],
  type: OperationType.conditional
}];


export const actionCannotBeRevertedWarningCompleteButton: Action = [{
  buttons: [{
    name: 'actionCannotBeRevertedWarning.btn',
    disabled: '!{buttonDisabled}'
  }],
  type: OperationType.updateDialog
}];

export const commentWarningCompleteButton: Action = [{
  buttons: [{
    name: 'commentWarning.btn',
    disabled: '!{buttonDisabled}'
  }],
  type: OperationType.updateDialog
}];


export const promotePing: Action = [{
  condition: '{promoteRequestData} && {promoteRequestData.processingFinished}',
  conditionOperations: [{
    moduleName: 'App',
    type: OperationType.unmaskModule
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'promoteNotification',
    type: OperationType.action
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'finishExecution',
    type: OperationType.action
  }],
  elseOperations: [{
    actionType: {
      dispatcherId: "batchPingDispatcher",
      delay: 1500
    },
    data: {
      template: {
        bind: {
          processId: '{promoteRequestData.processId}',
          actionName: '{actionName}'
        }
      }
    },
    name: 'promotePingRequest',
    type: OperationType.stack
  }],
  type: OperationType.conditional
}];

export const promotePingRequest: Action = [{
  data: {
    template: {
      method: 'post',
      headers: {
        bind: {
          'X-Process-Uuid': '{processId}'
        }
      },
      bind: {
        url: "'/submissions/' + {selectedSubmissions[0].submissionId} + '/' + {actionName}"
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'promoteRequestData',
  type: OperationType.request
}, {
  condition: `!!_.get({promoteRequestData}, "response.data.errors")`,
  conditionOperations: [{
    condition: `_.get({promoteRequestData},"response.data.errors[0].errorCode") === "REST.ERR.ACTION.INCOMPLETE"`,
    conditionOperations: [{
      name: 'incompleteFileUploadWarning',
      type: OperationType.action
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }],
    elseOperations: [{
      condition: `_.get({promoteRequestData},"response.data.errors[0].errorCode") === "REST.VALID.ACTION.DEMOTEIMPOSS"`,
      conditionOperations: [{
        data: {
          endpointPrefix: 'COMPLETE_',
        },
        type: OperationType.data
      }],
      type: OperationType.conditional
    }, {
      data: {
        template: {
          bind: {
            responseData: '{promoteRequestData}'
          }
        }
      },
      name: 'handleRequestException',
      args: ['responseData'],
      type: OperationType.action
    }, {
      actionType: {
        dispatcherId: 'mainDispatcher'
      },
      name: 'finishExecution',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    items: ['promoteRequestData'],
    type: OperationType.syncDispatchersDataItem
  }, {
    persistent: ['promoteRequestData'],
    type: OperationType.addPersistentData
  }, {
    name: 'promotePing',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const promoteNotification: Action = [{
  data: {
    template: {
      toasterModuleId: 'ToastNotificationsViewport'
    }
  },
  type: OperationType.data
}, {
  condition: '_.get({drawerState},"detached") && {appDetachedWindow}',
  conditionOperations: [{
    data: {
      template: {
        toasterModuleId: 'ToastNotificationsDrawer'
      }
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  evaluate: true,
  moduleName: 'ToastNotifications',
  moduleId: '{toasterModuleId}',
  name: 'createPromoteNotification',
  args: ['promoteRequestData', 'actionName']
}, {
  name: 'refreshApp',
  type: OperationType.action
}, {
  evaluate: true,
  moduleName: 'ToastNotifications',
  moduleId: '{toasterModuleId}',
  name: 'runStackedNotifications'
}];

export const finishExecution: Action = [{
  condition: '{executionModuleName} === "ReportDialog"', // if is ReportDialog close dialog !
  conditionOperations: [{
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  elseOperations: [{
    evaluate: true,
    moduleName: '{executionModuleName}',
    name: 'clearWarringFlags'
  }],
  type: OperationType.conditional
}, {
  persistent: ['actionName', 'selectAll', 'executionModuleName', 'promoteRequestData', 'promoteFilesAction', 'requestData', 'gsSaveRequestData'],
  type: OperationType.removePersistentData
}, {
  dispatcherIds: ['batchPingDispatcher'],
  type: OperationType.unlink
}];

export const hasCompletedFilesWarning: Action = [{
  placeholders: {
    className: 'tp-text-semibold'
  },
  warningType: WarningType.warning,
  className: 'sm warning footer-centered',
  title: 'filesTabPromoteDemoteWarnings.title',
  text: 'filesTabPromoteDemoteWarnings.hasCompletedFilesWarning.warningText',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }]
  }, {
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }],
    btnName: 'filesTabPromoteDemoteWarnings.close',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }],
  type: OperationType.warning
}];

export const linguistWithoutUploadWarning: Action = [{
  placeholders: {
    className: 'tp-text-semibold'
  },
  warningType: WarningType.warning,
  className: 'sm warning footer-centered',
  title: 'filesTabPromoteDemoteWarnings.title',
  text: 'filesTabPromoteDemoteWarnings.linguistWithoutUploadWarning.warningText',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }]
  }, {
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }],
    btnName: 'filesTabPromoteDemoteWarnings.close',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }],
  type: OperationType.warning
}];

export const incompleteFileUploadWarning: Action = [{
  warningType: WarningType.warning,
  placeholders: {
    template: {
      bind: {
        sendMailTo: '{initializeUserData.administratorEmail}',
        emailDisplayText: '{initializeUserData.administratorEmail}'
      }
    }
  },
  className: 'sm warning footer-centered',
  title: 'incompleteFileUploadWarning.title',
  text: 'incompleteFileUploadWarning.warningText',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }]
  }, {
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }],
    btnName: 'incompleteFileUploadWarning.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  type: OperationType.warning
}];

export const mandatoryGradeWarning: Action = [{
  warningType: WarningType.warning,
  className: 'sm warning footer-centered',
  title: 'gradeAndScoreWarnings.mandatoryGrade.title',
  text: 'gradeAndScoreWarnings.mandatoryGrade.text',
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }]
  }, {
    operations: [{
      name: 'clearPromoteData',
      type: OperationType.action
    }],
    btnName: 'common.cancel',
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }, {
    close: false,
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }, {
      condition: '{executionModuleName} === "ActionExecutor"',//complete from tasklist
      conditionOperations: [{
        data: {
          template: {
            jobPhaseFileViewParams: {
              folder: "JOB_PHASE_FILE",
              index: 0,
              orderBy: "taskId",
              size: 200,
              bind: {
                submissionId: '_.get({submissionData},`submissionId`)',
                taskId: '_.get({submissionData},`taskId`)'
              }
            }
          }
        },
        type: OperationType.data
      }, {
        data: {
          template: {
            method: 'post',
            url: '/jobPhaseFileView',
            bind: {
              params: '{jobPhaseFileViewParams}'
            }
          },
        },
        mappingName: 'gsTargets',
        type: OperationType.request
      }, {
        moduleName: 'ActionExecutor',
        name: 'transformRequestDataForGradingAndScoring',
        args: ['gsTargets', 'submissionData']
      }],
      elseOperations: [{
        data: {
          template: {
            selectAllFlag: {
              bind: {
                all: '{selectAll}'
              }
            }
          }
        },
        evaluate: true,
        moduleName: '{executionModuleName}',
        name: 'gradeAndScore',
        args: ['selectAllFlag']
      }],
      type: OperationType.conditional
    }],
    btnName: 'gradeAndScoreWarnings.mandatoryGrade.grading',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }],
  type: OperationType.warning
}];